import {cssTheme as rawCssTheme} from '@vio/atlas-tokens'

import {fonts} from './fonts'
import {typography} from './typography'

export enum ThemeNames {
  dealbase = 'dealbase',
  goseek = 'goseek',
  kayak = 'kayak',
  kiwi = 'kiwi',
  vio = 'vio',
  bookaway = 'bookaway',
  holidaypirates = 'holidaypirates',
  checkmybus = 'checkmybus',
  weward = 'weward',
  ovago = 'ovago',
  layla = 'layla'
}

const {
  custom,
  semantic,
  components,
  opacity,
  layout,
  shadow: shadows,
  newComponents,
  newSemantic,
  newCustom,
  newPrimitive
} = rawCssTheme

export const cssTheme = {
  colors: {
    ...components,
    ...custom,
    ...semantic
  },
  newColors: {
    ...newComponents,
    ...newCustom,
    ...newSemantic,
    ...newPrimitive
  },
  opacity,
  layout,
  shadows,
  fonts,
  typography
}
